import React, { useState, useEffect } from "react";
import "./SurveyComponent.css";

const images = [
  "newUserOnboarding.png", 
  "newUserOnboarding.png",
  "newUserOnboarding.png"
];


const idOrder = [1, 2, 3]; 

const SurveysOptions = () => {
  const [surveys, setSurveys] = useState([]);
  const [clicked, setClicked] = useState([false, false, false]);

  useEffect(() => {
    const fetchSurveys = async () => {
      try {
        const mockData = [
        { id: 1, title: "Client Onboarding \n Survey", enabled: false },
          { id: 2, title: "Client Effort Score \n (CES)", enabled: false },
          { id: 3, title: "Net Promoter Score \n (NPS)", enabled: false }
        ];

        const sortedSurveys = idOrder.map(id =>
          mockData.find(survey => survey.id === id) || {}
        );

        setSurveys(sortedSurveys);
      } catch (error) {
        console.error("Error fetching surveys:", error);
      }
    };

    fetchSurveys();
  }, []);

  const handleClick = (index) => {
    console.log(`Button ${index + 1} pressed, but it is disabled.`);
  };

  return (
    <div className="buttons-surveys">
      {surveys.length > 0 &&
        surveys.map((survey, index) => (
          <div key={survey.id || index} className="button-container">
            {!survey.enabled && <div className="coming-soon-text">Coming Soon...</div>}
            <button
              onClick={() => handleClick(index)}
              className={`button-surveys ${clicked[index]} ${!survey.enabled ? "disabled-button" : ""}`}
              disabled={!survey.enabled}
            >
              <img src={images[index]} alt={survey.title} className="size-buttom" />
            </button>
            <p className="button-text">
              {survey.title.split("\n").map((line, i) => (
                <React.Fragment key={i}>
                  {line}
                  <br />
                </React.Fragment>
              ))}
            </p>
          </div>
        ))}
    </div>
  );
};

export default SurveysOptions;